import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "CLIENT", {
  TEXT: "Client created succesfully",
  DELETE: "Client deleted succesfully",
});
